<script lang="ts" setup>
    import {defineAsyncComponent} from "vue";

    import DText from "../atoms/DText.vue";
    import DContainer from "../atoms/DContainer.vue";
    import type {KeyValueType} from "@songfinch/types";
    import type {BaseFormProps} from "@songfinch/types";

    withDefaults(defineProps<
        BaseFormProps & {
            options: string[] | KeyValueType[];
            type: "radio" | "optionPicker";
            attributeType?: "color" | "image" | undefined;
        }
    >(), {
        type: "radio",
        attributeType: undefined,
    });

    const selectComponentTypes = {
        radio: defineAsyncComponent(
            () => import("./DRadioButton.vue"),
        ),
        optionpicker: defineAsyncComponent(
            () => import("./DOptionPicker.vue"),
        ),
    };

    const model = defineModel<string | boolean>({default: false});
</script>

<template>
    <DContainer>
        <DText v-if="label" variant="form-label">
            {{label}}
        </DText>
        <DText v-if="subtext" variant="p-4">
            {{subtext}}
        </DText>

        <DContainer class="option-container">
            <template v-for="option in options" :key="option.id">
                <component
                    :is="selectComponentTypes[type]"
                    :id="id"
                    v-model="model"
                    :theme="theme"
                    :variant="attributeType"
                    :option="option"
                />
            </template>
        </DContainer>
    </DContainer>
</template>

<style lang="scss" scoped> 
    .option-container {
        display: flex;
        flex-wrap: wrap;
        column-gap: .625rem;
        row-gap: .625rem;
        margin-top: .75rem;
    }


    .single-select-flex-container {
        column-gap: .375rem;
        row-gap: .5rem;
        flex-wrap: wrap;
    }
</style>